// JSON-LD structured data builders (schema.org) for Talk N' Fix.
import { SITE_URL, BUSINESS, GEO } from "./siteConfig";

const postalAddress = {
  "@type": "PostalAddress",
  streetAddress: BUSINESS.streetAddress,
  addressLocality: BUSINESS.addressLocality,
  addressRegion: BUSINESS.addressRegion,
  postalCode: BUSINESS.postalCode,
  addressCountry: BUSINESS.addressCountry,
};

const openingHoursSpecification = BUSINESS.openingHours.map((h) => ({
  "@type": "OpeningHoursSpecification",
  dayOfWeek: h.days,
  opens: h.opens,
  closes: h.closes,
}));

// Primary local-business entity (MobilePhoneStore is a Store / LocalBusiness).
export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MobilePhoneStore"],
  "@id": `${SITE_URL}/#localbusiness`,
  name: BUSINESS.name,
  legalName: BUSINESS.legalName,
  description: BUSINESS.description,
  url: SITE_URL,
  telephone: BUSINESS.telephone,
  email: BUSINESS.email,
  image: BUSINESS.image,
  logo: BUSINESS.logo,
  priceRange: BUSINESS.priceRange,
  currenciesAccepted: "USD",
  paymentAccepted: "Cash, Credit Card, Debit Card",
  address: postalAddress,
  geo: {
    "@type": "GeoCoordinates",
    latitude: GEO.lat,
    longitude: GEO.lng,
  },
  hasMap: BUSINESS.mapUrl,
  areaServed: [
    { "@type": "City", name: "Freehold" },
    { "@type": "AdministrativeArea", name: "Monmouth County, NJ" },
  ],
  openingHoursSpecification,
  sameAs: BUSINESS.sameAs,
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: BUSINESS.ratingValue,
    reviewCount: BUSINESS.reviewCount,
    bestRating: "5",
    worstRating: "1",
  },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: BUSINESS.name,
  description: BUSINESS.description,
  publisher: { "@id": `${SITE_URL}/#localbusiness` },
  inLanguage: "en-US",
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const serviceSchema = (svc) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${SITE_URL}/services/${svc.slug}/#service`,
  name: svc.title,
  serviceType: svc.title,
  description: svc.short,
  url: `${SITE_URL}/services/${svc.slug}`,
  image: svc.image,
  areaServed: { "@type": "City", name: "Freehold, NJ" },
  provider: { "@id": `${SITE_URL}/#localbusiness` },
  offers: {
    "@type": "Offer",
    availability: "https://schema.org/InStock",
    priceCurrency: "USD",
    priceSpecification: {
      "@type": "PriceSpecification",
      priceCurrency: "USD",
    },
    warranty: {
      "@type": "WarrantyPromise",
      durationOfWarranty: { "@type": "QuantitativeValue", value: 6, unitCode: "MON" },
    },
  },
});

export const webPageSchema = ({ title, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${SITE_URL}${path}#webpage`,
  url: `${SITE_URL}${path}`,
  name: title,
  description,
  isPartOf: { "@id": `${SITE_URL}/#website` },
  about: { "@id": `${SITE_URL}/#localbusiness` },
  inLanguage: "en-US",
});


export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
